import React, { ChangeEvent, FC } from 'react'
import Button from '../button'
import QueryDate from '../orders/query-date'
import FoodSelector from './food-selector'
import { Food } from '../../../core/foods'
import { Brand, BrandCode } from '../../../core/brands'
import styles from '../../styles/modules/food-price-history/food-price-history.module.scss'

export interface FoodPriceHistoryFilterForm {
  foodId: string
  dateFrom: Date | null
  dateTo: Date | null
  brandCode: string
}

interface Props {
  formState: FoodPriceHistoryFilterForm
  onChange: (field: 'foodId' | 'brandCode', value: string) => void
  onFoodChange: (foodId: string) => void
  onClear: () => void
  onBrandChange: (brandCode: BrandCode | '') => void
  onChangeDateFrom: (date: Date | null) => void
  onChangeDateTo: (date: Date | null) => void
  foods: Food[]
  brands: Brand[]
  isAdmin: boolean
  isLoading: boolean
}

const FoodPriceHistoryFilters: FC<Props> = ({
  formState,
  onChange,
  onFoodChange,
  onClear,
  onBrandChange,
  onChangeDateFrom,
  onChangeDateTo,
  foods,
  brands,
  isAdmin,
  isLoading,
}) => {
  const handleFoodSelect = (foodId: string) => {
    onFoodChange(foodId)
  }

  const handleBrandSelect = (event: ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value as BrandCode | ''
    onChange('brandCode', value)
    onBrandChange(value)
  }

  return (
    <div className={styles.queryContainer}>
      {isAdmin && (
        <div className={styles.field}>
          <span className={styles.label}>ブランド</span>
          <select
            id="brand"
            name="brandCode"
            className={styles.control}
            value={formState.brandCode || ''}
            onChange={handleBrandSelect}
          >
            {brands.length === 0 ? (
              <option value="@loading" disabled>
                ブランドを取得中...
              </option>
            ) : (
              brands.map(brand => (
                <option key={brand.code} value={brand.code}>
                  {brand.name}
                </option>
              ))
            )}
          </select>
        </div>
      )}

      <div className={styles.field}>
        <span className={styles.label}>フード</span>
        <FoodSelector
          foods={foods}
          selectedFoodId={formState.foodId}
          onFoodChange={handleFoodSelect}
        />
      </div>

      <QueryDate
        from={formState.dateFrom}
        to={formState.dateTo}
        onChangeFrom={onChangeDateFrom}
        onChangeTo={onChangeDateTo}
      />

      <div className={styles.actions}>
        <Button
          title="クリア"
          onClick={onClear}
          isLoading={isLoading}
          className={styles.searchButton}
        />
      </div>
    </div>
  )
}

export default FoodPriceHistoryFilters
